import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import CryptoJS from 'crypto-js'
import Organization from '../../../../types/Organization'
import Provider from '../../../../types/Provider'
import User from '../../../../types/User'
import OrgClaim from '../../../../types/OrgClaim'
import ActionData from '../../../../types/ActionData'
import RootState from '../../../../types/RootState'
import { Row, Col, Form, Button, Card, Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap'
import CircularProgress from '@material-ui/core/CircularProgress'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator'
import DatePicker from 'react-datepicker'
import { CSVLink } from 'react-csv'
import ClaimModal from '../../../../components/Modals/ClaimModal'
import { getOrgClaims } from '../../../../redux/actions/claims'
import { addUserActivity } from '../../../../redux/actions/authentication'
import { formatDollar, formatUTCDate } from '../../../../utils/stringTools'
import { convert } from '../../../../utils/dataTools'
import moment from 'moment'
import './index.css'

interface Props {
  csvOrgClaims: ActionData;
  provider: Provider;
  orgClaims: Array<OrgClaim>;
  orgClaimsResult: ActionData;
  orgClaimsPagination: {
    sizePerPage: number;
    totalSize: number;
  };
  selectedOrganization: Organization;
  user: User;
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number; claimId?: number }, token: string ) => void;
  getOrgClaims: (id: number, page: number, sizePerPage: number, searchTerm: string, sFromStartDate: string | undefined, sFromEndDate: string | undefined, dPaidStartDate: string | undefined, dPaidEndDate: string | undefined, facility: string, sortField: string, sortOrder: string, type: string, token: string) => void;
}

class OrganizationClaims extends Component<Props> {
  private csvLink: any = createRef()

  state = {
    searchOpen: false,
    show: false,
    claim: undefined,
    serviceFromStartDate: undefined,
    serviceFromEndDate: undefined,
    datePaidStartDate: undefined,
    datePaidEndDate: undefined,
    searchTerm: '',
    facility: 'All',
    page: 1,
    totalSize: 0,
    sortField: null,
    sortOrder: null
  }

  componentDidMount() {
    const { orgClaimsPagination, selectedOrganization, getOrgClaims } = this.props

    if ( selectedOrganization.organization_id !== -1 ) {
      const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
      if ( token && token !== '' ) {
        getOrgClaims(selectedOrganization.organization_id, 1, orgClaimsPagination.sizePerPage, null, null, null, null, null, 'All', null, null, 'PAGING', token)
        this.setState({ page: 1 })
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { csvOrgClaims, orgClaimsPagination, selectedOrganization, getOrgClaims } = this.props

    if ( selectedOrganization !== prevProps.selectedOrganization && selectedOrganization.organization_id !== -1 ) {

      const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''

      if ( token && token !== '' ) {
        getOrgClaims(selectedOrganization.organization_id, 1, orgClaimsPagination.sizePerPage, null, null, null, null, null, 'All', null, null, 'PAGING', token)
      }
    }

    if ( orgClaimsPagination !== prevProps.orgClaimsPagination ) {
      this.setState({ totalSize: orgClaimsPagination.totalSize })
    }

    if ( csvOrgClaims !== prevProps.csvOrgClaims ) {
      if (csvOrgClaims.data && this.csvLink.current && this.csvLink.current.link) {
        setTimeout(() => {
          this.csvLink.current.link.click()
        })
      }
    }
  }

  applyFilters = () => {
    const { orgClaimsPagination, selectedOrganization, getOrgClaims } = this.props
    const { serviceFromStartDate, serviceFromEndDate, searchTerm, facility, datePaidStartDate, datePaidEndDate, sortField, sortOrder } = this.state
    const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
    
    getOrgClaims(selectedOrganization.organization_id, 1, orgClaimsPagination.sizePerPage, searchTerm, convert(serviceFromStartDate), convert(serviceFromEndDate), convert(datePaidStartDate), convert(datePaidEndDate), facility, sortField, sortOrder, 'PAGING', token)
    this.setState({ page: 1 })
  }

  clearFilters = () => {
    const { sortField, sortOrder } = this.state
    const { orgClaimsPagination, selectedOrganization, getOrgClaims } = this.props
    const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
    
    getOrgClaims(selectedOrganization.organization_id, 1, orgClaimsPagination.sizePerPage, null, null, null, null, null, 'All', sortField, sortOrder, 'PAGING', token)
    this.setState({
      serviceFromStartDate: undefined,
      serviceFromEndDate: undefined,
      datePaidStartDate: undefined,
      datePaidEndDate: undefined,
      facility: 'All',
      searchTerm: '',
      page: 1,
    })
  }

  closeModal = () => {
    this.setState({
      show: false
    })
  }

  formatClaimDataForCSV = (claims: Array<OrgClaim>, provider: Provider, organization: Organization) => {
    let data = claims
    if (!data || data === undefined || data.length === 0) {
      return []
    }
    const csv = data.map(claim => ({
      'Organization': organization.organization_name,
      'Tax ID': provider.tax_id_number,
      'Facility': claim.providerName,
      'Member ID': claim.memberId,
      'Last Name': claim.lastName,
      'First Name': claim.firstName,
      'Authorization No': claim.authNumber,
      'Denial Reason': claim.exCode,
      'Service Type': claim.serviceType,
      'Procedure Code': claim.proceduralCode,
      'Procedure Description': claim.proceduralDescription,
      'Units': claim.units,
      'Date Received': formatUTCDate(claim.dateReceived),
      'Service From': formatUTCDate(claim.serviceFrom),
      'Service To': formatUTCDate(claim.serviceTo),
      'Claim No': claim.claimNumber,
      'Check No': claim.checkNumber,
      'Date Paid': formatUTCDate(claim.datePaid),
      'Amount Billed': claim.billedAmount,
      'Amount Paid': claim.amountPaid
    }))
    return csv
  }

  handleChangeServiceStart = (date: Date) => {
    this.setState({
      serviceFromStartDate: date
    })
  }

  handleChangeServiceEnd = (date: Date) => {
    this.setState({
      serviceFromEndDate: date
    })
  }

  handleChangeDatePaidStart = (date: Date) => {
    this.setState({
      datePaidStartDate: date
    })
  }

  handleChangeDatePaidEnd = (date: Date) => {
    this.setState({
      datePaidEndDate: date
    })
  }

  handleSearchIconClicked = () => {
    this.setState({
      searchOpen: !this.state.searchOpen
    })
  }

  handleChangeString = (evt: any) => {
    this.setState({ [evt.target.name]: evt.target.value })
  }

  handleRowClick = (e: any, row: any) => {const { user, addUserActivity } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''

    this.setState({
      show: true,
      claim: row
    })

    addUserActivity({
      eid: email.eid,
      activity: 'View Claim',
      claimId: row.id,
    }, token)
  }

  handlePageChange = (page, sizePerPage) => {
    const { selectedOrganization, getOrgClaims } = this.props
    const { serviceFromStartDate, serviceFromEndDate, searchTerm, facility, datePaidStartDate, datePaidEndDate, sortField, sortOrder } = this.state
    const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
    
    this.setState({ page })
    getOrgClaims(selectedOrganization.organization_id, page, sizePerPage, searchTerm, convert(serviceFromStartDate), convert(serviceFromEndDate), convert(datePaidStartDate), convert(datePaidEndDate), facility, sortField, sortOrder, 'PAGING', token)
  }
  
  handleTableChange = (type, { sortField, sortOrder }) => {
    // handle any data change here
    if ( type === 'sort') {
      const { orgClaimsPagination, selectedOrganization, getOrgClaims } = this.props
      const { serviceFromStartDate, serviceFromEndDate, searchTerm, facility, datePaidStartDate, datePaidEndDate, page } = this.state
      const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
      
      this.setState({ sortField, sortOrder })
      getOrgClaims(selectedOrganization.organization_id, page, orgClaimsPagination.sizePerPage, searchTerm, convert(serviceFromStartDate), convert(serviceFromEndDate), convert(datePaidStartDate), convert(datePaidEndDate), facility, sortField, sortOrder, 'PAGING', token)
    }
  }

  handleDownloadActivity = () => {
    const { orgClaimsPagination, selectedOrganization, user, addUserActivity, getOrgClaims } = this.props
    const { serviceFromStartDate, serviceFromEndDate, searchTerm, facility, datePaidStartDate, datePaidEndDate, sortField, sortOrder } = this.state
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''

    getOrgClaims(selectedOrganization.organization_id, 1, orgClaimsPagination.sizePerPage, searchTerm, convert(serviceFromStartDate), convert(serviceFromEndDate), convert(datePaidStartDate), convert(datePaidEndDate), facility, sortField, sortOrder, 'CSV', token)
    addUserActivity({
      eid: email.eid,
      activity: 'Download Claims',
      organizationId: selectedOrganization.organization_id
    }, token)
  }

  render() {
    const { serviceFromStartDate, serviceFromEndDate, searchTerm, show, claim, facility, datePaidStartDate, datePaidEndDate, page, totalSize } = this.state
    const { user, provider, orgClaims, orgClaimsPagination, orgClaimsResult, csvOrgClaims, selectedOrganization } = this.props
    const handleRowEvents = {
      onClick: this.handleRowClick
    }
    const columns = [{
      dataField: 'providerName',
      text: 'Provider Name',
      sort: true,
      footer: ''
    }, {
      dataField: 'memberId',
      text: 'Member ID',
      sort: true,
      footer: ''
    }, {
      dataField: 'lastName',
      text: 'Last Name',
      sort: true,
      footer: ''
    }, {
      dataField: 'firstName',
      text: 'First Name',
      sort: true,
      footer: ''
    }, {
      dataField: 'authNumber',
      text: 'Auth. No.',
      sort: true,
      footer: ''
    }, {
      dataField: 'serviceType',
      text: 'Service Type',
      sort: true,
      footer: ''
    }, {
      dataField: 'proceduralCode',
      text: 'Proc. Code',
      sort: true,
      footer: ''
    }, {
      dataField: 'units',
      text: 'Units',
      sort: true,
      headerStyle: {
        width: '85px'
      },
      footer: ''
    }, {
      dataField: 'serviceFrom',
      text: 'Service From',
      sort: true,
      formatter: formatUTCDate,
      footer: ''
    }, {
      dataField: 'serviceTo',
      text: 'Service To',
      sort: true,
      formatter: formatUTCDate,
      footer: ''
    }, {
      dataField: 'datePaid',
      text: 'Date Paid',
      sort: true,
      formatter: formatUTCDate,
      footer: ''
    }, {
      dataField: 'billedAmount',
      text: 'Amt. Billed',
      sort: true,
      formatter: formatDollar,
      footer: columnData => formatDollar(columnData.reduce((acc, item) => acc + item, 0))
    }, {
      dataField: 'amountPaid',
      text: 'Amt. Paid',
      sort: true,
      formatter: formatDollar,
      footer: columnData => formatDollar(columnData.reduce((acc, item) => acc + item, 0))
    }, {
      dataField: 'exCode',
      text: 'Denial Reason',
      sort: true,
      formatter: (cellContent, row) => {
        if (cellContent !== null) {
          return (
            <div>
              <span>{cellContent}</span>
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip id={'tooltip-bottom'}>
                    {row.denialReason}
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color='#336699' style={{ alignSelf: 'center', marginLeft: 5 }} />
              </OverlayTrigger>
            </div>
          )
        }
        else {
          return cellContent
        }
      },
      footer: ''
    }]

    let data = <div>No Claims available</div>

    if (orgClaimsResult.loading === true)
      data = (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
          <CircularProgress size={40} />
          <span>Loading data</span>
        </div>
      )

    const csvData = this.formatClaimDataForCSV(csvOrgClaims.data, provider, selectedOrganization)

    return (
      <div>
        <Accordion style={{ marginBottom: 20, borderBottom: '1px solid rgba(0, 0, 0, 0.125)' }}>
          <Card>
            <Card.Header>
              <Row>
                <Accordion.Toggle as={Button} variant='link' eventKey='0'>
                  Search Claims
                </Accordion.Toggle>
              </Row>
            </Card.Header>
            <Accordion.Collapse eventKey='0'>
              <Card.Body>
                <div>
                  <Row>
                    <Col xs={3}>
                      <Form.Group>
                        <Form.Label>Service From: Date Range Start</Form.Label>
                        <DatePicker
                          dateFormat='M/d/yy'
                          selected={serviceFromStartDate}
                          selectsStart
                          startDate={serviceFromStartDate}
                          endDate={serviceFromEndDate}
                          onChange={this.handleChangeServiceStart}
                          className='datepicker'
                          placeholderText='Type date or click to select date'
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={3}>
                      <Form.Group>
                        <Form.Label>Service From: Date Range End</Form.Label>
                        <DatePicker
                          dateFormat='M/d/yy'
                          selected={serviceFromEndDate}
                          selectsEnd
                          startDate={serviceFromStartDate}
                          endDate={serviceFromEndDate}
                          onChange={this.handleChangeServiceEnd}
                          minDate={serviceFromStartDate}
                          className='datepicker'
                          placeholderText='Type date or click to select date'
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={3}>
                      <Form.Group>
                        <Form.Label>Date Paid: Date Range Start</Form.Label>
                        <DatePicker
                          dateFormat='M/d/yy'
                          selected={datePaidStartDate}
                          selectsStart
                          startDate={datePaidStartDate}
                          endDate={datePaidEndDate}
                          onChange={this.handleChangeDatePaidStart}
                          className='datepicker'
                          placeholderText='Type date or click to select date'
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={3}>
                      <Form.Group>
                        <Form.Label>Date Paid: Date Range End</Form.Label>
                        <DatePicker
                          dateFormat='M/d/yy'
                          selected={datePaidEndDate}
                          selectsEnd
                          startDate={datePaidStartDate}
                          endDate={datePaidEndDate}
                          onChange={this.handleChangeDatePaidEnd}
                          minDate={datePaidStartDate}
                          className='datepicker'
                          placeholderText='Type date or click to select date'
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <Form.Group>
                        <Form.Label>Facility</Form.Label>
                        <Form.Control as='select' name='facility' value={facility} onChange={this.handleChangeString}>
                          <option value='All'>All</option>
                          {
                            user.provider_data
                              ? user.provider_data.map(p => <option key={p.provider_id} value={p.provider_name}>{p.provider_name}</option>)
                              : null

                          }
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col xs={6}>
                      <Form.Group>
                        <Form.Label>Member Name, Authorization Number, or Procedural Code</Form.Label>
                        <Form.Control
                          placeholder='Enter Member Name, Authorization Number, or Procedural Code'
                          aria-label='Enter Member Name, Authorization Number, or Procedural Code'
                          name='searchTerm'
                          value={searchTerm}
                          onChange={this.handleChangeString}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={{ span: 2, offset: 8 }}>
                      <Button variant='outline-secondary' block onClick={this.clearFilters} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block' }}>Clear</Button>
                    </Col>
                    <Col xs={2}>
                      <Button variant='success' block onClick={this.applyFilters.bind(this, orgClaims)} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block' }}>Search</Button>
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
        <div style={{ width: '100%', marginTop: 10 }}>
          <PaginationProvider
            pagination={paginationFactory({
              custom: true,
              page: page,
              totalSize: totalSize,
              sizePerPage: orgClaimsPagination.sizePerPage,
              onPageChange: this.handlePageChange
            })}
          >
            {
              ({
                paginationProps,
                paginationTableProps,
              }) => (
                <div>
                  <ToolkitProvider
                    keyField='id'
                    bootstrap4
                    data={orgClaims}
                    columns={columns}
                    search
                  >
                    {
                      props => (
                        <div className='authorizations-table-container' style={{ width: '100%' }}>
                          {
                            csvOrgClaims.loading ? (
                              <div style={{ float: 'right', paddingBottom: 10 }}>
                                <Button variant='success' disabled>
                                  <div>Downloading <CircularProgress size={10} style={{ marginLeft: 10, color: 'white' }} /></div>
                                </Button>
                              </div>
                            ) :
                              csvData.length > 0 ? (
                                <CSVLink ref={this.csvLink} data={csvData} filename={`${selectedOrganization.organization_name}_Claims_${moment().format('YYYY-MM-DD')}.csv`} style={{ float: 'right', paddingBottom: 10 }}>
                                  <Button variant='success'>
                                    Download
                                  </Button>
                                </CSVLink>
                              ) : (
                                <div style={{ float: 'right', paddingBottom: 10 }}>
                                  <Button variant='success' onClick={this.handleDownloadActivity}>
                                    Download
                                  </Button>
                                </div>
                              )
                          }
                          <BootstrapTable
                            keyField='id'
                            remote
                            rowEvents={handleRowEvents}
                            noDataIndication={() => (data)}
                            striped
                            condensed
                            hover
                            onTableChange={this.handleTableChange}
                            {...paginationTableProps}
                            {...props.baseProps}
                          />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                  <PaginationTotalStandalone {...paginationProps} />
                  <PaginationListStandalone
                    {...paginationProps}
                  />
                </div>
              )
            }
          </PaginationProvider>
        </div>
        <ClaimModal show={show} onClose={this.closeModal} org={selectedOrganization.organization_name} provider={provider} claim={claim} />
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  csvOrgClaims: state.claims.csvOrgClaims,
  orgClaims: state.claims.orgClaims.data,
  orgClaimsPagination: state.claims.orgClaims.pagination,
  orgClaimsResult: state.claims.orgClaims,
  selectedOrganization: state.authentication.selectedOrganization,
  user: state.authentication.user.data
})

const mapDispatchToProps = {
  addUserActivity,
  getOrgClaims
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationClaims)